import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const toggleGroupingCenterlineDimensionMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Toggle centerline',
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ controller: { options }}): void => {
			options.showApplianceGroups = !options.showApplianceGroups;
		}
	};
};
